export default __webpack_public_path__ + "static/Plots0010-54d30732db0490d851f0941c4adf495f.jpg";